import React, { useEffect, useState } from 'react';
import useFetchWithAuth from '../hooks/useFetchWithAuth';

const ProtectedPage = () => {
  const [data, setData] = useState(null);
  const fetchWithAuth = useFetchWithAuth('https://api.reshipesbakery.com/api/protected');

  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchWithAuth();
      setData(result);
    };

    fetchData();
  }, [fetchWithAuth]);

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>Protected Data</h1>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
};

export default ProtectedPage;
